import { DELETE_COURSE } from "./query";
import { Delete, Tabs } from "../shared";
import ViewTier from "./ViewTier";
import { toast } from "react-toastify";
import UpdateTierDetails from "./UpdateTierDetails";
import ManageTierCourses from "./ManageTierCourses";

const SubComponent = ({ data, row }: any) => {
    const { id, tierName, orderNo, country } = data;

    return (
        <>
            <Tabs
                tabItems={[
                    {
                        id: `view-${id}`,
                        name: "View Tier",
                        content: <ViewTier data={data} />,
                    },
                    {
                        id: `update-${id}`,
                        name: "Update Tier",
                        content: (
                            <UpdateTierDetails
                                id={id}
                                tierName={tierName}
                                orderNo={orderNo}
                                country={country}
                                onUpdateSuccess={() => row.toggleExpanded()}
                            />
                        ),
                    },
                    {
                        id: `delete-${id}`,
                        name: "Delete Tier",
                        content: (
                            <Delete
                                title="Tier"
                                id={id}
                                query={DELETE_COURSE}
                                cacheName="allAllerganProTiers"
                                onDeleteError={(error) => {
                                    if (error.errorCode === "23503")
                                        toast.error(
                                            "Unable to delete the tier as it may still be in use."
                                        );
                                    else toast.error(error.message);
                                }}
                            />
                        ),
                    },
                    {
                        id: `manage-courses-${id}`,
                        name: "Manage Courses",
                        content: (
                            <ManageTierCourses
                                courses={data?.courseList?.nodes?.map(
                                    ({
                                        id: tierCourseId,
                                        courseId: id,
                                        courseName: name,
                                    }: any) => ({
                                        id,
                                        name,
                                        tierCourseId,
                                    })
                                )}
                                tierId={id}
                                tierName={tierName}
                                tierCountry={country}
                            />
                        ),
                    },
                ]}
            />
        </>
    );
};

export default SubComponent;
